import React, { FC, useEffect, useMemo, useState } from 'react'

import { ITag } from 'shared/interfaces'
import { TFilterPill } from 'shared/types'
import { cn } from 'shared/utils'

import { filtersSelection } from 'shared/utils/filtersSelection'

import FilterSelectionPill from './FilterSelectionPill'

import { FilterSelectionProps } from './FilterSelection.props'
import './FilterSelection.scss'

const FilterSelection: FC<FilterSelectionProps> = ({
  total,
  values,
  defaultValue,
  selectionLabels,
  resetValue,
  resetTagValue,
  reverseDirection
}) => {
  const [pillsSelection, setPills] = useState<TFilterPill[]>([])

  const isDefaultValues = useMemo(() => JSON.stringify(values) === JSON.stringify(defaultValue), [defaultValue, values])
  const selectionTitle = isDefaultValues ? 'Showing' : 'Your filter selection resulted in'

  useEffect(() => {
    setPills(isDefaultValues ? [] : filtersSelection(values, defaultValue, selectionLabels))
  }, [defaultValue, isDefaultValues, selectionLabels, values])

  return (
    <div className={cn('filter-selection', { reverse: reverseDirection })}>
      <div className="filter-selection__result">
        {selectionTitle} {total}.
      </div>
      {pillsSelection.map((pill: TFilterPill) =>
        pill.value === 'tags' ? (
          (pill.label as ITag[]).map((pillTag: ITag) => (
            <FilterSelectionPill key={pillTag.id} pillName={pillTag.label} onReset={resetTagValue(pillTag.id)} />
          ))
        ) : (
          <FilterSelectionPill key={pill.value} pillName={pill.label as string} onReset={resetValue(pill.value)} />
        )
      )}
    </div>
  )
}

export default FilterSelection
